import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Country } from 'react-phone-number-input';
import { getCountryCallingCode, parsePhoneNumber } from 'react-phone-number-input/input';
import en from 'react-phone-number-input/locale/en.json';
import PrefixSelect from './PrefixSelect';
import { useField } from 'remix-validated-form';

const PhoneInputGroup = ({
  forceStackedLayout = false,
  showErrorText = false,
  mobileNumberWithPrefix,
}: {
  forceStackedLayout?: boolean;
  showErrorText?: boolean;
  mobileNumberWithPrefix?: string | null;
}) => {
  const { t } = useTranslation();
  const mobileNumberObject = parsePhoneNumber(mobileNumberWithPrefix || '');

  const { error, clearError } = useField('mobileNumberWithPrefix');
  const [mobileNumber, setMobileNumber] = useState(mobileNumberObject?.nationalNumber || '');
  const [country, setCountry] = useState<Country | undefined>(mobileNumberObject?.country || 'FR');

  useEffect(() => {}, [mobileNumber, country]);

  const buildMobileNumberWithPrefix = () => {
    let mobileNumberWithPrefix = '';

    if (country) {
      mobileNumberWithPrefix += `+${getCountryCallingCode(country)}`;
    }
    if (mobileNumber) {
      mobileNumberWithPrefix += mobileNumber;
    }
    return mobileNumberWithPrefix;
  };

  return (
    <div
      className={`input-group ${
        forceStackedLayout ? 'phone-inputs-stacked flex-column' : 'flex-column flex-md-row'
      } phone-inputs`}
    >
      <PrefixSelect
        onChange={setCountry}
        value={country}
        labels={en}
      />

      <div className="form-floating">
        <input
          readOnly
          type="hidden"
          value={buildMobileNumberWithPrefix()}
          name="mobileNumberWithPrefix"
        />

        <input
          readOnly
          type="hidden"
          value={getCountryCallingCode(country || 'FR')}
          name="mobilePrefix"
        />

        <input
          type="text"
          className={`form-control ${error ? 'is-invalid' : ''}`}
          name="mobileNumber"
          placeholder="Mobile number"
          value={mobileNumber}
          onChange={(e) => {
            setMobileNumber(e.target.value);
            clearError();
          }}
        />
        <label>{t('dashboard.userDetails.form.personalPhoneNumber')}</label>
        {showErrorText && !!error && <div className="text-2 -regular color-error-600 mt-1">{error}</div>}
      </div>
    </div>
  );
};

export default PhoneInputGroup;
